<template>
  <div ref="waringContainer" class="waring-container">
    <div class="logo-out"><div class="logo">!</div></div>
    <div ref="waringTop" class="waring-top">
      <p ref="waringContent" v-html="msgTip"></p>
    </div>
  </div>

</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'WaringTop',
  computed: {
    ...mapState(['msgTip'])
  },
  mounted() {
    this.$nextTick(() => {
      const waringTop = this.$refs.waringTop
      const waringContent = this.$refs.waringContent
      const waringContainer = this.$refs.waringContainer
      if (this.msgTip && waringContent.offsetWidth >= (waringContainer.offsetWidth - 27)) {
        this.scrollLeft(waringTop, waringContent, 20)
      }
    })
  },
  methods: {
    ...mapMutations(['SET_MSG_TIP']),
    scrollLeft(waringTop, waringContent, speed) {
      let time = setInterval(this.Marquee(waringTop, waringContent), speed)
      waringTop.onmouseover = () => {
        clearInterval(time)
      }
      waringTop.onmouseout = () => {
        time = setInterval(this.Marquee(waringTop, waringContent), speed)
      }
    },
    Marquee(waringTop, waringContent) {
      return () => {
        if (waringTop.scrollLeft + waringTop.offsetWidth >= waringContent.scrollWidth) {
          const msgTip = this.msgTip
          let message = msgTip + msgTip
          if (msgTip.length > 200) {
            message = msgTip.split('&nbsp;')
            message = message.slice(message.length - 3)
            message = message.join('&nbsp;')
          }
          this.SET_MSG_TIP(message)
        } else {
          waringTop.scrollLeft++
        }
      }
    }

  }
}
</script>

<style scoped lang="stylus" >
  .waring-container{
    background-color: #FEFCEB;
    display flex
    align-items center
    height 33px
    .logo-out{
      padding-left 8px;
      padding-right 4px;
      .logo{
        width 17px
        height 17px
        min-width 17px
        max-width 17px
        border-radius 50%
        background-color: #F96A0E
        color #fff
        text-align center
        line-height 17px
        font-size 14px
        font-weight bolder
      }
    }
    .waring-top{
      font-size 13px
      color #F96A0E
      display flex
      align-items center
      box-sizing border-box
      overflow hidden
      overflow-x auto
      padding-left 1px
      &::-webkit-scrollbar {
        display none
      }
      p{
        white-space nowrap
        flex 1
        -webkit-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
        user-select:none;
      }
    }

  }
</style>
